export default __webpack_public_path__ + "static/media/frutas.d3039c3e.jpg";